import { useForgotPasswordMutation } from '@config/state/globalSlices/apiSlice/mutations';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { createNotification } from '@shared/utils/createNotification';
import { forgotPasswordSchema } from 'compositions/auth/Form/schemas';
import { Form, Formik } from 'formik';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

import AuthHeader from '../Components/AuthHeader';
import Input from '../Components/Input';
import SecondaryButton from '../Components/SecondaryButton';
import SubmitButton from '../Components/SubmitButton';

const initialValues = {
  email: '',
};

export default function ResetPassword() {

  const navigate = useNavigate();
  const [submitForgotPasswordForm, { isLoading: isSubmitting }] = useForgotPasswordMutation();
  const media = useMediaQuery('(max-width: 600px)')

  const handleSubmit = async (values: {email: string}) => {
    try {
      await submitForgotPasswordForm({ username: values.email }).unwrap()
      createNotification({
        message: 'Check your email! If we recognised your account, we’ve sent instructions to reset your password.',
        type: 'success',
        position: media ? 'top-center' :'bottom-center'
      });

    } catch (error){
      createNotification({
        message: 'Oops! Looks like there was an issue submitting the form, please try again!',
        type: 'error',
        position: media ? 'top-center' :'bottom-center'
      });
    }
  };

  return (
    <div className="w-full">
      <Helmet title="PHMG | Password Reset" />
      <AuthHeader title="Password reset" />

      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateSchema={forgotPasswordSchema}
        validateOnMount={true}
      >
        <Form className='text-[14px]'>
          <Input label="Email or username" name="email" type="text" />

          <SubmitButton disabled={isSubmitting} text={isSubmitting ? 'Resetting password...' : 'Reset password'} type="submit" />
        </Form>
      </Formik>
      <SecondaryButton text="Back to login" onClick={() => navigate('/ap/login')} icon />
    </div>
  );
}
